import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import CmsBackend from './cmsBackend';
import { initReactI18next } from 'react-i18next';

import { formatAsDistance, formatAsEmission } from 'cpie-common';

i18n.use(LanguageDetector)
    .use(CmsBackend)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        load: 'languageOnly',
        preload: ['en'],
        ns: [
            'contracts',
            'dashboard',
            'dealer-card',
            'financial-contract-header',
            'financial-details',
            'greeting',
            'my-profile',
            'my-profile-address-details',
            'my-profile-contact-details',
            'my-profile-marketing-preferences',
            'marketing-preferences-email',
            'navigation',
            'notifications',
            'registration',
            'request',
            'third-party-licenses',
            'translation',
            'vehicle-details',
            'dashboard-cms',
            'marketing-cards',
            'faq-cms',
            'footer-cms',
            'profile-cms',
            'request-cms',
            'navigation-cms',
        ],
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
            format(value, format) {
                if (format === 'distance') {
                    return formatAsDistance(value);
                }
                if (format === 'emission') {
                    return formatAsEmission(value);
                }
                return value;
            },
        },
        backend: {
            cmsNamespaces: [
                'dashboard-cms',
                'marketing-cards',
                'faq-cms',
                'footer-cms',
                'profile-cms',
                'request-cms',
                'navigation-cms',
            ],
        },
        whitelist: ['en', 'en'],
    });

export default i18n;
